import React from "react";
import PropTypes from "prop-types";
import { Box, FormControl, Input, FormLabel, Divider, Tooltip } from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
const SubmitButton = ({ field, handleOnChange }) => {
	const styleClasses = field.styleClasses.length ? field.styleClasses.join(" ") : "";
	return (
		<Box mt="3">
			<FormControl mb="3">
				<FormLabel fontSize="13px">Submit Button Text</FormLabel>
				<Input
					size="sm"
					type="text"
					value={field.name}
					placeholder="Enter label"
					onChange={(e) => handleOnChange(e, "name")}
				/>
			</FormControl>
			<Divider />
			<FormControl mt="3">
				<FormLabel fontSize="13px">
					Form css class{" "}
					<Tooltip
						ml="2"
						label="Enter multiple css classes separated by space"
						aria-label="A tooltip"
					>
						<InfoOutlineIcon />
					</Tooltip>
				</FormLabel>
				<Input
					size="sm"
					type="text"
					value={styleClasses}
					placeholder="Enter css class name"
					onChange={(e) => handleOnChange(e, "styleClasses")}
				/>
			</FormControl>
		</Box>
	);
};

SubmitButton.propTypes = {
	field: PropTypes.object.isRequired,
	handleOnChange: PropTypes.func.isRequired,
};

export default SubmitButton;
